<div class="container-fluid text-center dial-ali">
          <button class="close-btn" mat-icon-button (click)="close()" aria-label="Close Personality Types">
  <mat-icon>close</mat-icon>
</button>
  <div class="row justify-content-center">
    <div class="col-12 col-md-12">

      <h2 class="h2 my-4 opus-header">The Executor</h2>
      <p class="mb-5">
        You excel in structured environments where tasks are clearly defined, and you take pride in getting things done efficiently.
        Repetition or chaos can drain you, as you thrive when there’s a clear plan to follow.
      </p>

      <h2 class="h2 my-4">The Guardian</h2>
      <p class="mb-5">
        Loyalty and responsibility drive you, and you feel energized when protecting or nurturing others.
        You thrive in stable, community-oriented environments but can feel frustrated in situations lacking commitment or order.
      </p>

      <h2 class="h2 my-4">The Oracle</h2>
      <p class="mb-5">
        You gain energy from deep thinking and exploring abstract ideas, thriving in intellectual environments.
        Mundane tasks can cause you to lose interest, as you crave stimulating and visionary discussions.
      </p>

      <h2 class="h2 my-4">The Strategist</h2>
      <p class="mb-5">
        You are driven by ambition and excel in environments that require careful planning and long-term thinking.
        You may lose interest in fast-paced, unplanned environments and prefer working where strategy guides success.
      </p>

      <h2 class="h2 my-4">The Rebel</h2>
      <p class="mb-5">
        Independence and flexibility are essential for you to thrive, and you enjoy environments where you can make your own decisions.
        Routine or rigid structures stifle your creativity and sense of freedom.
      </p>

      <h2 class="h2 my-4">The Creator</h2>
      <p class="mb-5">
        Creativity and self-expression energize you, and you thrive in environments that allow for artistic exploration.
        Monotonous tasks or overly structured environments can drain your focus and enthusiasm.
      </p>

      <h2 class="h2 my-4">The Dreamer</h2>
      <p class="mb-5">
        Imagination and idealism fuel your energy, and you love environments that nurture your creativity and vision.
        Repetition and practicality may drain you, as you seek inspiration and possibilities beyond the ordinary.
      </p>

      <h2 class="h2 my-4">The Philosopher</h2>
      <p class="mb-5">
        You are energized by exploring complex ideas and logical analysis in intellectually stimulating environments.
        Mundane tasks or environments that lack deep discussion can quickly bore you.
      </p>

      <h2 class="h2 my-4">The Risk-Taker</h2>
      <p class="mb-5">
        You thrive in energetic, fast-paced environments where adventure and action are key.
        Predictability and a lack of challenge can make you lose focus, as you constantly seek new, exciting experiences.
      </p>

      <h2 class="h2 my-4">The Showman</h2>
      <p class="mb-5">
        Social interactions and creativity recharge you, and you excel in environments where fun and performance are valued.
        When the atmosphere is too serious or lacks engagement, your energy tends to fade.
      </p>

      <h2 class="h2 my-4">The Spark</h2>
      <p class="mb-5">
        You’re driven by spontaneity and the excitement of new ideas, and thrive in dynamic environments full of possibilities.
        Routine or repetitive work drains your energy, as you seek fresh challenges and inspiration.
      </p>

      <h2 class="h2 my-4">The Disruptor</h2>
      <p class="mb-5">
        Boldness and a love for challenging norms fuel you, and you excel in environments that value change and innovation.
        Predictable or unchanging situations stifle your creativity, and you constantly seek to shake things up.
      </p>

      <h2 class="h2 my-4">The Commander</h2>
      <p class="mb-5">
        Leadership and efficiency energize you, and you thrive in structured, goal-oriented environments.
        Disorganization or unclear leadership can frustrate you, as you prefer taking charge and moving toward clear objectives.
      </p>

      <h2 class="h2 my-4">The Host</h2>
      <p class="mb-5">
        Social interaction and creating a sense of community energize you, and you thrive when you can bring people together.
        You may feel drained in environments that lack connection or social interaction.
      </p>

      <h2 class="h2 my-4">The Charmer</h2>
      <p class="mb-5">
        You gain energy from engaging and inspiring others, excelling in social settings that require emotional intelligence and persuasion.
        When interactions become distant or impersonal, you may feel disconnected and lose focus.
      </p>

      <h2 class="h2 my-4">The Powerhouse</h2>
      <p class="mb-5">
        Ambition and strategy fuel you, and you excel in environments that value leadership and decisive action.
        You may feel disengaged when environments lack vision or when your strategic insight isn’t recognized.
      </p>

    </div>
  </div>
</div>
